import React from 'react'
import { EColor } from '@frontend/pole-ui/lib/common/constants'
import type { IIconProps } from '@frontend/pole-ui/lib/components/Icon'
import { EIconSize } from '@frontend/pole-ui/lib/components/Icon'
import { EmptyIcon } from '@frontend/pole-ui/lib/components/Icon/svg/EmptyIcon'
import { ErrorIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ErrorIcon'
import { OkFillIcon } from '@frontend/pole-ui/lib/components/Icon/svg/OkFillIcon'
import { Renewalofold1FillIcon } from '@frontend/pole-ui/lib/components/Icon/svg/Renewalofold1FillIcon'
import { TextWithIcon } from '@/components/ui'
import type { EDocumentStatus } from '@/types/Documents'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import type { IAccreditationDocumentsStatusProps } from '../interfaces'

const emptyIconProps: IIconProps = {
  component: <EmptyIcon />,
  style: { opacity: 0.5, color: EColor.GREEN },
}

export const DocumentStatusIcon: Record<EDocumentStatus, IIconProps> = {
  REJECTED: {
    component: <ErrorIcon />,
    style: { color: EColor.RED },
  },
  PROPOSED: {
    component: <OkFillIcon />,
    style: { color: EColor.GREEN },
  },
  UPDATED: {
    component: <Renewalofold1FillIcon />,
    style: { color: EColor.ORANGE },
  },
  APPROVED: {
    component: <OkFillIcon />,
    style: { color: EColor.GREEN },
  },
}

const DocumentStatus: React.FC<IAccreditationDocumentsStatusProps> = ({ status }) => {
  const { isMobile } = useDeviceType()

  return (
    <TextWithIcon
      textClassName="color_pale-black-sm"
      iconProps={
        status
          ? { ...DocumentStatusIcon[status], size: isMobile ? EIconSize.XS : EIconSize.M }
          : { ...emptyIconProps, size: isMobile ? EIconSize.XS : EIconSize.M }
      }
      textId={`userAccreditation.document.status.${status}`}
    />
  )
}

export default DocumentStatus
